import { computed, defineComponent, PropType } from 'vue';
import { InfoFilled } from '@element-plus/icons-vue';
import { HintMap } from '@/models/common/hint/hint-map.model';

export default defineComponent({
  name: 'HintComponent',
  components: { InfoFilled },
  props: {
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    hintList: {
      type: Object as PropType<HintMap>,
      required: true,
      default: () => ({}),
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const hintInfo = props.hintList[props.name];
    const isShowHintTitle = computed<boolean>(
      () => props.showTitle && (!!props.title?.length || !!hintInfo.title?.length),
    );

    return {
      hintInfo,
      isShowHintTitle,
    };
  },
});
